import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api/deep-dive`;

export const deepDiveApi = {
  questionnaire: (tier) => axios.get(`${API}/questionnaire/${encodeURIComponent(tier)}`),
  start:         (purchase_token) => axios.post(`${API}/start`, { purchase_token }),
  saveAnswers:   (token, answers, current_section_key) =>
    axios.patch(`${API}/by-token/${encodeURIComponent(token)}/answers`, { answers, current_section_key }),
  complete:      (token, final_answers = {}) =>
    axios.post(`${API}/by-token/${encodeURIComponent(token)}/complete`, { final_answers }),
  get:           (token) => axios.get(`${API}/by-token/${encodeURIComponent(token)}`),
  summary:       (token) => axios.get(`${API}/by-token/${encodeURIComponent(token)}/summary`),
};
